/**
 * The domain's name in the legacy.
 * @type {string}
 */
import { USER_MODEL_KEY_POINTER } from 'models/daos/user/constants'

const USERS_DOMAIN = 'users'

/**
 * The initial state of the domain.
 * @type {DomainMap}
 */
const USERS_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {},
  current: null
}

/**
 * The store paths.
 * @type {Object}
 */
const USERS_PATH = {
  ALL: `${USERS_DOMAIN}.all`,
  DATA: `${USERS_DOMAIN}.data`,
  CURRENT: `${USERS_DOMAIN}.current`
}

/**
 * The api routes.
 * @type {Object}
 */
const USERS_ENDPOINT = {
  AUTHENTICATE: '/auth/authenticate',
  SIGNUP: '/auth/signup',
  SIGNIN: '/auth/signin',
  SIGNOUT: '/auth/signout',
  SIGN_UP_GUEST: '/auth/sign-up-guest'
}

const USERS_DOMAIN_MAP_KEY = USER_MODEL_KEY_POINTER

export {
  USERS_DOMAIN_MAP_KEY,
  USERS_DOMAIN,
  USERS_PATH,
  USERS_ENDPOINT,
  USERS_STATE
}
